module.exports = __webpack_public_path__ + "static/media/filter-icon.aebb5a9c.svg";